<template>
  <ul>
     <el-popover placement="bottom" trigger="click">
      <div class="ms">
        <img src="@/assets/image/cdcia.png" width="90" alt="" class="float-l">
        <p v-if="store.lang === 'zh_CN'">辽宁省脑血管病临床医学协同创新联盟（CDCIA）是由北部战区总医院神经内科和辽宁省脑血管病临床医学研究中心发起，辽宁省科技厅批准成立，辽宁省科协作为业务主管单位，辽宁省卫健委指导下的公益性非盈利协会组织。作为集医疗、教学、科研、预防、宣教于一体的临床医学协同创新联盟，其以脑血管病为靶目标疾病，以临床多中心研究为主线，将临床培训、科学研究、技术推广等有机结合，通过推广创新诊疗方法及预防模式，促进辽宁省脑血管病基础及临床研究领域创新发展，提升脑血管病的诊治和科研能力，降低发病率、死亡率、致残率，减轻家庭、社会和政府的负担。</p>
        <p v-else>
          Liaoning Cerebrovascular Disease Clinical Medicine Collaborative Innovation Alliance (CDCIA) was initiated by the Department of Neurology, General Hospital of the Northern Theater Command and Liaoning Provincial Cerebrovascular Disease Clinical Medical Research Center, approved by the Liaoning Provincial Department of Science and Technology, and Liaoning Provincial Science and Technology Cooperation as the business supervisor. A public welfare non-profit association organized under the guidance of the Provincial Health Commission.
          As a clinical medical collaborative innovation alliance integrating medical treatment, teaching, scientific research, prevention, and publicity, it takes cerebrovascular disease as the target disease, takes clinical multi-center research as the main line, and organically combines clinical training, scientific research, and technology promotion, through the promotion of innovative diagnosis and treatment methods and prevention models, promotes the innovation and development of basic and clinical research on cerebrovascular diseases in Liaoning Province, improves the ability of diagnosis, treatment and scientific research of cerebrovascular diseases, reduces morbidity, mortality, and disability rates, and relieves family, social and government burden pressure.
        </p>
      </div>
       <li class="pro-details" slot="reference">
      <img src="@/assets/image/experiment1.png" class="pro-icon" />
      <a href="javascript:void(0);" class="pro-item">{{$t('top.common.introductiontoAssociation')}}</a>
    </li>
    </el-popover>
    <!-- <li class="pro-details" @click="dialogTableVisible ">
      <img src="@/assets/image/experiment5.png" class="pro-icon" />
      <a href="javascript:void(0);" class="pro-item">主要研究者简介</a>
    </li> -->
    <el-popover placement="bottom" trigger="click">
      <div :class="[store.lang=== 'zh_CN'?'title-zh':'title-en','ms']">
      <p><span>{{$t('top.common.name')}}</span>{{ConnectPI[store.lang].name}}</p>
      <p><span>{{$t('top.common.phone')}}</span>{{ConnectPI[store.lang].phone}}</p>
      <p><span>{{$t('top.common.email')}} </span>{{ConnectPI[store.lang].email}}</p>
      <p style="display:flex;"><span>{{$t('top.common.address')}}</span><span>{{ConnectPI[store.lang].address}}<br/>{{ConnectPI[store.lang].address1}}</span>
      </p>
      </div>
      <li class="pro-details" slot="reference">
        <img src="@/assets/image/experiment2.png" class="pro-icon" />
        <a href="javascript:void(0);" class="pro-item">{{$t('top.common.ConnectPI')}}</a>
        <!-- <img src="@/assets/image/down.png" class="down-icon" /> -->
      </li>
    </el-popover>
    <el-popover placement="bottom" trigger="click">
        <div :class="[store.lang=== 'zh_CN'?'title-zh':'title-en','ms']">
      <p><span>{{$t('top.common.name')}}</span>{{ConnectPM[store.lang].name}}</p>
      <p><span>{{$t('top.common.phone')}}</span>{{ConnectPM[store.lang].phone}}</p>
      <p><span>{{$t('top.common.email')}}</span>{{ConnectPM[store.lang].email}}</p>
      <p><span>{{$t('top.common.address')}}</span>{{ConnectPM[store.lang].address}}</p>
      </div>
      <li class="pro-details" slot="reference">
        <img src="@/assets/image/experiment3.png" class="pro-icon" />
        <a href="javascript:void(0);" class="pro-item">{{$t('top.common.ConnectPM')}}</a>
        <!-- <img src="@/assets/image/down.png" class="down-icon" /> -->
      </li>
    </el-popover>
    <el-popover placement="bottom" trigger="click" width="1000">
      <p class="mt">{{$t('top.common.projectIntroduction')}}:</p>
      <p class="md">INTACT-CHINA</p>
      <p class="ms" v-if="store.lang === 'zh_CN'">
        重组人TNK组织型纤溶酶原激活剂治疗急性脑梗死的有效性和安全性研究：前瞻、多中心登记研究（INtravenous
        TNK for Acute isChemic sTroke in China
        (INTACT-China)）。由中国人民解放军北部战区总医院牵头发起，共有50家分中心参与，预计入组1000例受试者，本研究拟进行前瞻、多中心登记研究，记录rhTNK-tPA治疗急性脑梗死的真实世界情况，旨在评价rhTNK-tPA溶栓药物在中国缺血性卒中人群中的有效性和安全性。
      </p>
      <p class="ms" v-else>
        Efficacy and safety of recombinant human TNK tissue plasminogen activator in the treatment of acute cerebral infarction: a prospective, multicenter registry study (INtravenous TNK for Acute isChemical sTroke in China (INTACT-China)). Initiated by the General Hospital of the Northern Theater Command, a total of 50 sub-centers participated, and 1,000 subjects are expected to be enrolled. This study plans to conduct a prospective, multi-center registration study to record the real-world situation of rhTNK-tPA in the treatment of acute cerebral infarction , to evaluate the efficacy and safety of rhTNK-tPA thrombolytic drugs in Chinese ischemic stroke population.
      </p>
      <p class="md">EXIT-BT</p>
      <p class="ms" v-if="store.lang === 'zh_CN'">
        丁苯酞保护下的急性超窗脑梗死的替奈普酶溶栓治疗：前瞻性、随机、开放标签、盲法评价结局的多中心研究（EXtending
        the tIme window of Thrombolysis by ButyphThalide up to 6 hours after
        onset
        (EXIT-BT)）。由中国人民解放军北部战区总医院牵头发起，共有10家分中心参与，预计入组100例受试者，本课题拟探讨在静脉应用丁苯酞的同时，发病4.5-6小时急性脑梗死的进行替奈普酶溶栓治疗的有效性与安全性。
      </p>
      <p class="ms" v-else>
        Thrombolysis with tenecteplase in acute super-window cerebral infarction protected by butylphthalide: a prospective, randomized, open-label, blinded multicenter study onset EXtending the tIme window of Thrombolysis by ButyphThalide up to 6 hours after onset (EXIT-BT)). Initiated by the General Hospital of the Northern Command, a total of 10 sub-centers participated, and 100 subjects are expected to be enrolled. This project intends to explore the efficacy and safety of tenecteplase thrombolytic therapy in acute cerebral infarction within 4.5-6 hours of onset while intravenously administering butylphthalide.
      </p>
      <p class="md">DETECT2</p>
      <p class="ms" v-if="store.lang === 'zh_CN'">
        血管内治疗急性缺血性卒中：前瞻、全国多中心的真实世界登记研究（enDovascular
        trEatmenT for acutE isChemic sTroke in China
        (DETECT2-China)）。由中国人民解放军北部战区总医院牵头发起，共有30家分中心参与，预计入组3000例受试者，本研究拟进行前瞻、多中心登记研究，记录中国人群血管内治疗急性脑梗死的真实世界情况，旨在评价血管内治疗技术在中国缺血性卒中人群中的实际疗效和安全性。
      </p>
      <p class="ms" v-else>
        Endovascular therapy for acute ischemic stroke: a prospective, national multicenter real-world registry study (enDovascular trEatmenT for acutE isChemical sTroke in China (DETECT2-China)). Initiated by the General Hospital of the Northern Theater Command, a total of 30 sub-centers participated, and 3,000 subjects are expected to be enrolled. This study plans to conduct a prospective, multi-center registration study to record the real world of endovascular treatment of acute cerebral infarction in the Chinese population The purpose of this study was to evaluate the actual efficacy and safety of endovascular therapy in the Chinese ischemic stroke population.
      </p>
      <p class="md">HRMRI-ICAS</p>
      <p class="ms"  v-if="store.lang === 'zh_CN'">
        缺血性卒中颅内血管高分辨磁共振的前瞻性、多中心队列研究（High-resolution
        magnetic resonance imaging of intracranial atherosclerotic plaques
        in ischemic stroke
        (HRMRI-ICAS)）。由中国人民解放军北部战区总医院牵头发起，共有20家分中心参与，预计入组2103例受试者，本研究拟建立多中心缺血性卒中颅内动脉高分辨影像数据库。
      </p>
      <p class="ms"  v-else>
       High-resolution magnetic resonance imaging of intracranial atherosclerotic plaques in ischemic stroke (HRMRI-ICAS), a prospective, multicenter cohort study. Initiated by the General Hospital of the Northern Theater Command, a total of 20 sub-centers participated, and 2103 subjects were expected to be enrolled. This study plans to establish a multi-center ischemic stroke intracranial artery high-resolution imaging database.
      </p>
      <p class="md">ARMS</p>
      <p class="ms"  v-if="store.lang === 'zh_CN'">
        抗栓治疗对缺血性卒中患者脑微出血和颅内出血的影响（The impact of
        anti-thrombosis on cerebral microbleeds and intracranial hemorrhage
        in ischemic stroke patients
        (ARMS)）。由中国人民解放军北部战区总医院牵头发起，共有20家分中心参与，预计入组1875例受试者，本前瞻性队列研究的目的是探讨缺血性卒中二级预防中抗栓治疗是否会增加新发CMBs的风险，以及这种增加是否和颅内出血风险增加有关，为此类患者个体化抗栓治疗提供影像学依据。
      </p>
      <p class="ms"  v-else>
        The impact of anti-thrombosis on cerebral microbleeds and intracranial hemorrhage in ischemic stroke patients (ARMS). Initiated by the General Hospital of the Northern Theater Command, a total of 20 sub-centers participated, and 1875 subjects were expected to be enrolled. The purpose of this prospective cohort study was to explore whether antithrombotic therapy would increase in the secondary prevention of ischemic stroke The risk of new CMBs, and whether this increase is related to the increased risk of intracranial hemorrhage, provides imaging evidence for individualized antithrombotic therapy in such patients.
      </p>
      <li class="pro-details" slot="reference">
        <img src="@/assets/image/experiment4.png" class="pro-icon" />
        <a href="javascript:void(0);" class="pro-item">{{$t('top.common.projectIntroduction')}}</a>
        <!-- <img src="@/assets/image/down.png" class="down-icon" /> -->
      </li>
    </el-popover>
    <li class="pro-details" slot="reference">
      <img src="@/assets/image/experiment5.png"  class="pro-icon" />
      <a href="/#/login" class="pro-item">{{$t('top.common.supportPlatform')}}</a>
    </li>
    
  </ul>
</template>

<script>
import {store} from '@/store/index'
export default {
  data() {
    return {
      store,
      ConnectPI:{
        zh_CN:{
          name:'陈会生',
          phone:'13352452086',
          email:'chszh@aliyun.com',
          address:'辽宁省沈阳市沈河区文化路83号',
          address1:'中国人民解放军北部战区总医院'
        },
        en_US:{
          name:'Hui-Sheng Chen',
          phone:'13352452086',
          email:'chszh@aliyun.com',
          address:`General Hospital of Northern Theater Command`,
          address1:'No.83 Wenhua Rd Shenyang Liaoning China'
        }
      },
      ConnectPM:{
  zh_CN:{
          name:'王秋爽',
          phone:'18602448980',
          email:'CDCIA_liaoning@aliyun.com',
          address:'辽宁省沈阳市沈河区青年大街茂业金廊1号 3017'
        },
        en_US:{
          name:'Qiu-Shuang Wang',
          phone:'18602448980',
          email:'CDCIA_liaoning@aliyun.com',
          address:`Room 3017 Maoyejinlang No.1 Qingnian St Shenyang Liaoning China`
        }
      },
    };
  },
  methods: {
    dialogTableVisible() {
      this.$emit("dialogTableVisible")
    }
  }
};
</script>
<style scoped>
.float-l{
  float: left;
}
ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin:0 18px 12px 18px;
  height: 56px;
  padding:0 63px;
  box-shadow: 0 1px 4px 0 rgba(0,21,41,0.12);
  border-radius: 4px;
  background: #fff;
  list-style: none;
  z-index: 10;
  /* padding-inline-start: 0 !important; */
}
.pro-details {
  display: flex;
  justify-content: space-between;
  margin-right: 120px;
  align-items: center;
  margin-right: 28px;
}
.pro-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.pro-item {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #454458;
  text-decoration: none;
}
.down-icon {
  width: 9px;
  height: 5px;
  margin-left: 5px;
}
.el-popover p  {
  margin: 0;
  padding: 0;
  max-width:1000px;
}
p.mt {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 16px;
  color: #373c48;
}
.md {
  line-height: 26px;
  color: #373c48;
  font-weight: 600;
}
.ms {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 24px;
}
.ms p span:first-child{
  display: inline-block;
  text-align: right;
  margin-right: 3px;
}
.title-en p span:first-child{
  margin-right: 10px;
  min-width: 50px;
}
</style>